define([
        'components/dropdown',
        'core/utilities'
    ],
    function(DD, utilities) {
        let nodes = {
            accessWrappers: document.querySelectorAll(".access-wrapper.has-selector"),
            firstName: document.querySelector("#id_first_name"),
            firstNameError: document.querySelector(".error.first-name"),
            lastName: document.querySelector("#id_last_name"),
            lastNameError: document.querySelector(".error.last-name"),
            email: document.querySelector("#id_email"),
            emailError: document.querySelector(".error.email"),
            title: document.querySelector("#id_professional_title"),
            titleError: document.querySelector(".error.title"),
        };

        let toggleAccessLevel = (wrapper, checkbox) => {
            let accessSelector = wrapper.querySelector(".access-level");
            checkbox.checked ? accessSelector.classList.remove("disabled") : accessSelector.classList.add("disabled") 
        }

        let dropdowns = {};

        let validationConfigs = [
            {
                input: nodes.firstName,
                errorNode: nodes.firstNameError,
                validations: ["hasValue", "alphaNumeric"],
            },
            {
                input: nodes.lastName,
                errorNode: nodes.lastNameError,
                validations: ["hasValue", "alphaNumeric"],
            },
            {
                input: nodes.email,
                errorNode: nodes.emailError,
                validations: ["email", "hasValue"],
            },
            {
                input: nodes.title,
                errorNode: nodes.titleError,
                validations: ["hasValue", "alphaNumeric"],  
            },
        ];

        return {
            init: function () {
                nodes.accessWrappers.forEach((wrapper) => {
                    let checkbox = wrapper.querySelector("input[type='checkbox']");
                    let selectWrapper = wrapper.querySelector(".access-level");

                    checkbox.addEventListener("change", () => {
                        toggleAccessLevel(wrapper, checkbox);
                    })

                    // enable dropdown UI
                    dropdowns[wrapper.dataset.type] = DD(selectWrapper, () => {});

                    toggleAccessLevel(wrapper, checkbox);
                })

                let saveButton = document.querySelector(".submit");
                let form = document.querySelector("form");

                saveButton.addEventListener("click", () => {
                    let formIsValid = utilities.validateForm(validationConfigs);

                    if(formIsValid) {
                        saveButton.classList.add("loading");
                        form.submit();
                    }
                })
            }
        };
    }
);
